import bugsnag from 'bugsnag-js'
const bug = bugsnag('91bb623f674484e6a090ea839c1a8c00')
export default bug



// WEBPACK FOOTER //
// ./src/bugsnag.js